import { Box, Button } from "@mui/material";
import { resetChallenge, toAmazon } from "./container";

const Anounce: React.FC = () => {
  return (
    <Box flex="display">
      <Box ml={1} mb={1} mt={2}>
        <Button variant="contained" color="inherit" onClick={resetChallenge}>
          最初の問題に戻る
        </Button>
      </Box>
      <Box
        onClick={toAmazon}
        fontWeight={"bold"}
        style={{ cursor: "pointer", textDecoration: "underline" }}
        color="#1976d2"
        flexDirection={"column"}
        fontFamily="yasashisa"
        mt={2}
        mb={1}
        sx={{ fontSize: { xs: 13, md: 28 } }}
      >
        「あいうえパズル」発売中！（Amazon公式サイト）
      </Box>
      <img
        src={`${process.env.PUBLIC_URL}/images/anounce.jpg`}
        alt="Anounce"
        width="100%"
      />
      <Box mb="auto">© 2022 Kousuke Kajimura</Box>
    </Box>
  );
};

export default Anounce;
